import { combineReducers } from "redux";
import user from "./user";
import cart from "./cart";
import jwt from "./jwt";
import referral_code from './referral_code';
import request from "./request";
import identity_token from './identity_token';

export default combineReducers({
  user,
  cart,
  request,
  jwt,
  referral_code,
  identity_token
});